module.exports = __webpack_public_path__ + "img/25.0d1e38fd.png";